import { supabase } from "@/integrations/supabase/client";

const ROW_ID = 1;

export interface DadosEmpresaRow {
  id: number;
  razao_social: string | null;
  cnpj: string | null;
  telefone_contato: string | null;
  email_contato: string | null;
  cep: string | null;
  estado: string | null;
  cidade: string | null;
  rua: string | null;
  numero: string | null;
  complemento: string | null;
  updated_at: string;
}

export interface DadosEmpresaForm {
  razaoSocial: string;
  cnpj: string;
  telefoneContato: string;
  emailContato: string;
  cep: string;
  estado: string;
  cidade: string;
  rua: string;
  numero: string;
  complemento: string;
}

function rowToForm(row: DadosEmpresaRow | null): DadosEmpresaForm {
  if (!row) {
    return {
      razaoSocial: "",
      cnpj: "",
      telefoneContato: "",
      emailContato: "",
      cep: "",
      estado: "",
      cidade: "",
      rua: "",
      numero: "",
      complemento: "",
    };
  }
  return {
    razaoSocial: row.razao_social ?? "",
    cnpj: row.cnpj ?? "",
    telefoneContato: row.telefone_contato ?? "",
    emailContato: row.email_contato ?? "",
    cep: row.cep ?? "",
    estado: row.estado ?? "",
    cidade: row.cidade ?? "",
    rua: row.rua ?? "",
    numero: row.numero ?? "",
    complemento: row.complemento ?? "",
  };
}

/** Busca os dados da empresa (única linha, id=1) */
export async function getDadosEmpresa(): Promise<DadosEmpresaForm> {
  const { data, error } = await supabase
    .from("dados_empresa")
    .select("*")
    .eq("id", ROW_ID)
    .single();

  if (error) {
    if (error.code === "PGRST116") {
      return rowToForm(null);
    }
    console.error("Erro ao buscar dados da empresa:", error);
    throw new Error(error.message ?? "Erro ao buscar dados da empresa");
  }

  return rowToForm(data as DadosEmpresaRow);
}

/** Atualiza os dados da empresa. Apenas admin (RLS). */
export async function updateDadosEmpresa(
  form: DadosEmpresaForm
): Promise<DadosEmpresaForm> {
  const payload = {
    razao_social: form.razaoSocial || null,
    cnpj: form.cnpj.replace(/\D/g, "") || null,
    telefone_contato: form.telefoneContato.replace(/\D/g, "") || null,
    email_contato: form.emailContato || null,
    cep: form.cep.replace(/\D/g, "") || null,
    estado: form.estado || null,
    cidade: form.cidade || null,
    rua: form.rua || null,
    numero: form.numero || null,
    complemento: form.complemento || null,
  };

  const { data, error } = await supabase
    .from("dados_empresa")
    .update(payload)
    .eq("id", ROW_ID)
    .select()
    .single();

  if (error) {
    console.error("Erro ao atualizar dados da empresa:", error);
    throw new Error(error.message ?? "Erro ao salvar dados da empresa");
  }

  return rowToForm(data as DadosEmpresaRow);
}
